
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgotten-password",
      function () {
        return require("private-next-pages/forgotten-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgotten-password"])
      });
    }
  